export const baseURL = "https://backend.dotasks.in/api/"
// export const baseURL = "https://devbackend.dotasks.in/api/"
export const appName = "DoTasks"
